
import { dialog } from '@/plugins/dialog/index'
import InstanceBox from './index.vue';
/**
 * 选择内容分类
 */
export default function (options) {
  options = Object.assign({
    multiple: true
  }, options);
  return dialog({
    title: '内容分组',
    content() {
      return <InstanceBox options={options}></InstanceBox>
    }
  })
}